import { useContext } from "react";
import { Link } from "react-router-dom";

import { Dropdown, Col, Divider, Row, Button, Avatar } from "antd-v4";
import { UserOctagon } from "iconsax-react";

// => Context
import { FirebaseContext } from "../../../context/firebaseContext";

export default function HeaderUser() {
  const { signOutUser, userData } = useContext(FirebaseContext);

  const menu = (
    <div className="hp-user-dropdown hp-border-radius hp-bg-black-0 hp-bg-dark-100 hp-border-color-dark-80 hp-py-24 hp-px-18 hp-mt-16">
      <Row>
        <Col span={24}>
          <Link
            to="/profile/personal-information"
            className="hp-d-flex-center hp-p1-body hp-font-weight-500 hp-my-4 hp-py-8 hp-px-10 hp-d-block hp-transition hp-hover-bg-primary-4 hp-hover-bg-dark-80 hp-border-radius"
            style={{ marginLeft: -10, marginRight: -10 }}
          >
            <UserOctagon size="20" />
            <span className="hp-ml-8">Voir mon profil</span>
          </Link>
        </Col>
      </Row>

      <Divider className="hp-my-18" />

      <Row gutter={[0, 24]}>
        <Col span={24}>
          <Button
            onClick={signOutUser}
            type="primary"
            className="hp-bg-black-100 hp-border-color-black-100 hp-hover-bg-black-80 hp-hover-border-color-black-80"
          >
            Se déconnecter
          </Button>
        </Col>

        <Col
          span={24}
          className="hp-caption hp-text-color-black-80 hp-text-color-dark-30"
        >
          <span>Connecté en tant que {userData.email}</span>
        </Col>
      </Row>
    </div>
  );

  return (
    <Col className="hp-ml-8">
      <Dropdown overlay={menu} placement="bottomLeft">
        <div className="hp-border-radius-xl hp-cursor-pointer hp-border-1 hp-border-color-dark-80">
          <div
            className="hp-border-radius-lg hp-overflow-hidden hp-bg-info-4 hp-m-4 hp-d-flex"
            style={{ minWidth: 32, width: 32, height: 32 }}
          >
            {userData && (
              <Avatar
                size={48}
                src={userData.avatar}
                className="hp-bg-info-4"
              />
            )}
          </div>
        </div>
      </Dropdown>
    </Col>
  );
}
